import type { SearchParams } from '@/server/searchParams.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import {
  formatDateShortDayMonth,
  formatDateShortDayMonthIsomorphic,
} from '@/app/components/search/utils/dates/utilDates.ts';
import { isValidDate } from '@/app/components/search/Utilities.ts';

const isValidDateString = (date: string | undefined): date is string => !!date && isValidDate(new Date(date));

export const getShortsDatesText = ({
  searchParams,
  localization,
  dealCard,
  isWaiting,
}: {
  searchParams: SearchParams;
  localization: Localization;
  dealCard?: DealCard;
  isWaiting: boolean;
}) => {
  const locale = localization?.locale;
  const checkin = dealCard?.product?.dates?.checkin;
  const checkout = dealCard?.product?.dates?.checkout;
  const dateFrom = isWaiting ? searchParams?.[URLParameters.DATE_FROM] : checkin;
  const dateTo = isWaiting ? searchParams?.[URLParameters.DATE_TO] : checkout;

  return dateFrom && dateTo
    ? `${formatDateShortDayMonth(locale, dateFrom)} - ${formatDateShortDayMonth(locale, dateTo)}`
    : undefined;
};

export const getShortsDatesWithMonthText = ({
  searchParams,
  localization,
  dealCard,
  isWaiting,
}: {
  searchParams: SearchParams;
  localization: Localization;
  dealCard?: DealCard;
  isWaiting: boolean;
}) => {
  const locale = localization?.locale;
  const checkin = dealCard?.product?.dates?.checkin;
  const checkout = dealCard?.product?.dates?.checkout;
  const dateFrom = isWaiting ? searchParams?.[URLParameters.DATE_FROM] : checkin;
  const dateTo = isWaiting ? searchParams?.[URLParameters.DATE_TO] : checkout;

  return isValidDateString(dateFrom) && isValidDateString(dateTo)
    ? `${formatDateShortDayMonthIsomorphic(locale, dateFrom)} - ${formatDateShortDayMonthIsomorphic(locale, dateTo)}`
    : undefined;
};
